import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//components
import { InvertedSection, SectionTitle } from '@/components/Grid/Section';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const BackgroundSection = styled(InvertedSection)`
  background-color: rgb(${getToken('color-background-secondary')});
  padding: 50px 0 0;

  ${screen.md} {
    padding: 80px 0 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const Title = styled(SectionTitle)`
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  color: rgb(${getToken('color-text-primary')});
  margin: 0px;
  font-size: 38px;
  line-height: 48px;

  br:nth-child(1) {
    display: none;
  }

  ${screen.md} {
    font-size: 48px;
    line-height: 60px;

    br:nth-child(2) {
      display: none;
    }
    br:nth-child(1) {
      display: inline-block;
    }
  }

  ${screen.lg} {
    br:nth-child(1),
    :nth-child(2) {
      display: none;
    }
  }
`;

export const VideoThumb = styled.div`
  margin: 50px 0 0;
  height: 176px;
  width: 314px;

  ${screen.md} {
    height: 305px;
    width: 541px;
  }

  ${screen.lg} {
    height: 392px;
    width: 696px;
  }

  ${screen.xxlg} {
    height: 560px;
    width: 996px;
    margin: 100px 0 0;
  }
`;
